
import { Component, effect, input, output, signal } from '@angular/core';

@Component({
  selector: 'lib-sliding-side-view',
  imports: [],
  templateUrl: './sliding-side-view.component.html',
  styleUrls: ['./sliding-side-view.component.scss'],
})
export class SlidingSideViewComponent {
  readonly isOpen = input<boolean>(false);
  readonly width = input<string>('400px');
  readonly position = input<'left' | 'right'>('right');
  readonly title = input<string | null>(null);

  readonly handleClose = output<void>();

  // Internal state for animation
  showPanel = signal(false);
  animatePanel = signal(false);
  fadeBackdrop = signal(true);

  // Touch gesture tracking
  private touchStartY = 0;
  private touchCurrentY = 0;
  private isDragging = false;

  constructor() {
    effect(() => {
      const open = this.isOpen();
      if (open) {
        // Show panel first, then animate
        this.showPanel.set(true);
        this.fadeBackdrop.set(true);
        setTimeout(() => this.animatePanel.set(true), 10);
      } else {
        // Animate out first, then hide
        this.animatePanel.set(false);
        this.fadeBackdrop.set(false);
        setTimeout(() => this.showPanel.set(false), 300);
      }
    });
  }

  onClose() {
    this.handleClose.emit();
  }

  onBackdropClick() {
    this.handleClose.emit();
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartY = event.touches[0].clientY;
    this.touchCurrentY = this.touchStartY;
    this.isDragging = true;
  }

  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;

    this.touchCurrentY = event.touches[0].clientY;
    const deltaY = this.touchCurrentY - this.touchStartY;

    // Only allow downward swipe (positive deltaY) on mobile
    if (deltaY > 0) {
      // Find the parent panel element
      const indicator = event.currentTarget as HTMLElement;
      const panel = indicator.closest('.sliding-panel') as HTMLElement;
      if (panel) {
        panel.style.transform = `translateY(${deltaY}px)`;
        panel.style.transition = 'none';
      }
    }
  }

  onTouchEnd(event: TouchEvent) {
    if (!this.isDragging) return;

    const deltaY = this.touchCurrentY - this.touchStartY;

    // Find the parent panel element
    const indicator = event.currentTarget as HTMLElement;
    const panel = indicator.closest('.sliding-panel') as HTMLElement;

    if (panel) {
      // Reset transform and transition
      panel.style.transform = '';
      panel.style.transition = '';
    }

    // Close if swiped down more than 100px
    if (deltaY > 100) {
      this.handleClose.emit();
    }

    this.isDragging = false;
    this.touchStartY = 0;
    this.touchCurrentY = 0;
  }
}
